import { Component } from '@angular/core';
import { FileUploadZoneComponent } from '../../shared/components/file-upload-zone/file-upload-zone.component';

@Component({
  selector: 'app-period-comparison',
  imports: [FileUploadZoneComponent],
  templateUrl: './period-comparison.component.html',
})
export class PeriodComparisonComponent {
  protected onFiles(_files: File[]): void {
    // Trend engine — planned in a later phase.
  }
}
